var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "container",
    staticClass: "stats-container"
  }, [_c('a-tabs', {
    staticClass: "stats-tabs",
    attrs: {
      "default-active-key": "2"
    }
  }, [_c('a-tab-pane', {
    key: "1"
  }, [_c('span', {
    staticClass: "tab-label",
    attrs: {
      "slot": "tab"
    },
    slot: "tab"
  }, [_c('a-icon', {
    attrs: {
      "type": "bar-chart"
    }
  }), _c('span', {
    staticClass: "tab-text"
  }, [_vm._v(_vm._s(_vm._trs('Aggregated curve')))])], 1), _c('BidAskCurves')], 1), _c('a-tab-pane', {
    key: "2"
  }, [_c('span', {
    staticClass: "tab-label",
    attrs: {
      "slot": "tab"
    },
    slot: "tab"
  }, [_c('a-icon', {
    attrs: {
      "type": "line-chart"
    }
  }), _c('span', {
    staticClass: "tab-text"
  }, [_vm._v(_vm._s(_vm._trs('Data chart')))])], 1), _c('DayAheadResult')], 1), _c('a-tab-pane', {
    key: "3"
  }, [_c('span', {
    staticClass: "tab-label",
    attrs: {
      "slot": "tab"
    },
    slot: "tab"
  }, [_c('a-icon', {
    attrs: {
      "type": "table"
    }
  }), _c('span', {
    staticClass: "tab-text"
  }, [_vm._v(_vm._s(_vm._trs('Data table')))])], 1), _c('Tables')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }